module.exports = {
  emptyMessage: 'Silakan masukkan nama Anda',
  defaultMessage: 'Nama tidak valid',
};
